import { fromJS } from 'immutable';

import {ApiUrl2, UserToken, PrevilageId, ClientId, DivisionId} from '../../../helper/HelperAuth'
import { GetWAProfile, GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, body,isadmin) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true});
    const Authorization = UserToken;
    const urlAccess = ApiUrl2 + 'config-accessmodule-list';
    var paramBodyAccess = {
        "query":{
            "privilege-id":PrevilageId,
        }
    };
    const argumentAccess = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBodyAccess)
    };

    const responseAccess = await doFetch(urlAccess,argumentAccess);
    let dataAccess = fromJS({});
    let array = [];
    let action = 0;
    let show = '';
    if(responseAccess.ok){
        dataAccess = fromJS(await responseAccess.json());
        dataAccess = dataAccess.get('query-result');
    }

    let menuPrev = fromJS(dataAccess).get('data')
    {menuPrev.map((data, i) =>
        array.push({
            'menu-name' :data.get('menu-name'),
            'action-id' : data.get('action-id')
        })

    )}
    for (let i = 0; i < array.length; i++) {
        if (array[i]['menu-name'] === 'List Upload') {
            action = array[i]['action-id']
        }
    }

    if (body === '' || body === null || body === undefined) {
        let client_id = 0;
        let division_id = 0;
        let sender = [""];
        if (PrevilageId != 1 && isadmin == false) {
            client_id = ClientId;
            division_id = DivisionId;

            body = {
                "client-id": client_id,
                "division-id": division_id,
                "sender-id" : sender,
                "upload-by": "",
                "filename": "",
                "servicetype": 0,
                "upload-status": 0,
                "date-start": "",
                "date-end": ""
            }
        }

    }


    var query = {
        "search" : body,
        "page":page,
        "page-size":10,
        "order-by":5,
        "order":"DESC",
    };

    if (action == 3 || action == 4) {
        query = {
            "search" : body,
            "page":page,
            "page-size":10,
            "order-by":5,
            "order":"DESC",
            "show" : 'all'
        };
    }

    const url = ApiUrl2 + '/upload-list';

    if(page === undefined){
        page = 1;
    }

    if(search != null){
        search.map((v,k)=>{
            if(v !== ""){
                query[k] = v;
            }
        });
    }
    var paramBody = {
        "query": query
    };

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
    }


    dispatch({ type: GlobalLoading, showLoading: false});
    dispatch({ type: GetWAProfile, data: fromJS(data), action: action });
};